export enum EFilaTabsEdit {
  Filas = 1,
  Atendentes = 2,
  Devices = 3,
  Motivos = 4,
}